<template>
  <form class="main-modal main-modal_w600" @submit.prevent="saveSkill">
    <div class="main-modal__title">
      <p v-if="!isUpdate">{{ $t("forms.createSkill") }}</p>
      <p v-else>{{ $t("forms.updateSkill") }}</p>
    </div>

    <div class="main-form__box">
      <label class="main-form__label">{{ $t("listsHeader.skillName") }}</label>
      <input
        type="text"
        class="main-form__input"
        v-model="skill.name"
        :placeholder="$t('listsHeader.skillName')"
      />
    </div>

    <div class="main-form__buttons main-form__buttons_center">
      <span @click="$emit('close')" class="main-button main-button_cancel">
        {{ $t("global.cancel") }}
      </span>
      <button
        type="submit"
        :disabled="!isValid"
        class="main-button main-button_success"
      >
        {{ $t("global.save") }}
      </button>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
    name: 'skillsModal',
    props: {
        isUpdate: {
            required: false,
            default: false,
        },
    },
    computed: {
        ...mapGetters({
            skill: 'skills/skill',
        }),
        isValid() {
            return !(this.skill.name === '' || this.skill.name === null)
        },
    },
    methods: {
        ...mapMutations({
            setState: 'skills/setState',
        }),
        saveSkill() {
            this.$emit('done')
        },
    },
    beforeDestroy() {
        this.setState({
            key: 'skill',
            data: {
                name: '',
            },
        })
    },
}
</script>
